import React, {useEffect, useState} from 'react';
import './App.css';
import Homepage from "./components/Homepage";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import netlifyIdentity from "netlify-identity-widget";
import Projectpage from "./components/Projectpage";
import IFrame from "./components/IFrame";
import {GoogleOAuthProvider} from "@react-oauth/google";

function App() {
    const [user, setUser] = useState<any>(null);
    useEffect(() => {
        netlifyIdentity.init({
            APIUrl: "https://bimmy.netlify.app/.netlify/identity",
            logo: false
        });
        netlifyIdentity.on('login', (user) => {
            setUser(user);
            netlifyIdentity.close();
        });
        netlifyIdentity.on('logout', () => setUser(null));
        setUser(netlifyIdentity.currentUser());
    }, []);

    return (
        <GoogleOAuthProvider clientId="586143929623-u7hru1mactd42b2n8lvh8ut99uslngs7.apps.googleusercontent.com">
            <React.Fragment>
                <Router>
                    <Routes>
                        <Route path="/" element={<Homepage user={user}/>}/>
                        <Route path="frame">
                            <Route path=":noteID" element={<IFrame user={user}/>}/>
                        </Route>
                        <Route path="project" element={<Projectpage user={user}/>}>
                            <Route path=":projectID" element={<Projectpage user={user}/>}/>
                        </Route>
                    </Routes>
                </Router>
            </React.Fragment>
        </GoogleOAuthProvider>
    );
}

export default App;
